import React, { Fragment } from 'react';
import { Icon, Popup } from 'semantic-ui-react';

import '../animate.css';

const AwsUserCustomTooltip = (props) => {

    return (
        <Fragment>
        {/* <Popup
            trigger={<Icon name="copy" className="copy-icon" onClick={props.handleCopyClick} />}
            content={<span className={props.clicked ? "info-content animated flash" : "info-content"}>
                        {props.clicked ? "Copied!" : "Copy to clipboard"}
                    </span>}
            hoverable
            style={{cursor: "pointer"}}
            basic
        /> */}
        <span className="hasTooltip">
            <div className="info-content">
                Click here for more information on AWS Identity and Access Management
            </div>
            <Icon name="external alternate" />
        </span>
        </Fragment>
    )
}

export default AwsUserCustomTooltip;